import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
  selector: 'app-additional-partner-info-popup',
  templateUrl: './additional-partner-info-popup.component.html',
  styleUrls: ['./additional-partner-info-popup.component.scss']
})
export class AdditionalPartnerInfoPopupComponent {
  @Input()
  additionalPartnerInfo: string;
  @Input()
  auditInfoLoading: boolean;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onHit: EventEmitter<string> = new EventEmitter<string>();  
  constructor() {}

  handleClick(name): void {
    this.onHit.emit(name);
  }
}
